import { useState, useEffect } from 'react';
import Product from '../interfaces/Product';
import { useParams } from "react-router";
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { getProducts } from '../Products.service';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import ButtonBackComponent from '../../../component/buttton/ButtonBack.component';
import { useStore } from '../../../context/Store';
import TabsComponent from '../../../component/switchButtons/TabsComponents';
import Warranty from "./Warranty/Warranty";
import Security from "./Security/Security";
import AccidentalDamage from "./AccidentalDamage/AccidentalDamage";
import Combo from "./Combo/Combo";
import InstallmentMeans from "./InstallmentMeans/InstallmentMeans";
import Stock from "./Stock/Stock";
import Progress from "../../../component/progress/Progress.component";
import { Container } from "../../../component/container/Container";
import { getProductDetails } from "./ProductDetails.services";
import ServiceInformation from './components/ServiceInformation.component';
import { AxiosError } from "axios";
import { ResponseProduct } from "../interfaces/ResponseProduct";
import { CardStyled } from "../../../component/card/CardStyle";

export default function ProductDetails() {

  let { id } = useParams<ParamTypes>();
  const { store } = useStore();
  const [storeStock, setStoreStock] = useState<String>('');
  const [product, setProduct] = useState<Product>(INITIAL_VALUES);
  const [options, setOptions] = useState<ResponseProduct[]>([]);
  const [optionsServices, setOptionsServices] = useState<ResponseProduct[]>([]);
  const [reload, setReload] = useState<boolean>(true);
  const [reloadProduct, setReloadProduct] = useState<boolean>(true);
  const [reloadStock, setReloadStock] = useState<boolean>(false);

  useEffect(() => {
    let product = INITIAL_VALUES;
    product.LOJA = [storeStock || store];
    product.EAN = splitString(id)[2];
    getProducts(product).then((res) => {
      setProduct(res.data.ET_RELATORIO[0]);
    }).catch((error) => {
      console.log('Erro ao consultar produto');
    }).finally(() => {
      setReloadProduct(false);
      setReloadStock(false);
    })
  }, [id, storeStock, store]);

  const splitString = (id: string): string[] => {
    return id.split('-')
  }

  useEffect(() => {
    response();
  }, []);

  const response = async () => {
    await getProductDetails({ codigo: Number(splitString(id)[2]), loja: store.replace('B', '') }).then((response) => {
      setOptions(response.data);
      response.data.shift();
      if (response.data.length) {
        setOptionsServices(response.data);
      }
    }).catch((error: AxiosError) => {
      console.log(error.response?.data);
    }).finally(() => {
      setReload(false);
    })
  }

  const handleStoreStock = (value: string) => {
    setReloadStock(true);
    setStoreStock(value);
  }

  if (reloadProduct || reload) {
    return <Progress open={reloadProduct || reload} />
  }

  return (
    <CardStyled padding="12px">
      <ButtonBackComponent to='/produtos' />
      {reloadStock ? <Container margin="79px 0px 79px 0px"><Progress open={reloadStock} position="relative" /></Container> : <ServiceInformation product={product} />}
      <br />
      <TabsComponent nameTabs={['Estoque', 'Garantia Estendida', 'Furto e Roubo', 'Danos Acidentais', 'Combo (FR + DA)', 'Formas de Parcelamento']} index={1}>
        <Stock product={product} handleStoreStock={handleStoreStock} />
        {reload ? <Container margin="40px 0px 0px 0px"><Progress open={reload} position="relative" /></Container> : <Warranty options={options} />}
        {reload ? <Container margin="40px 0px 0px 0px"><Progress open={reload} position="relative" /></Container> : <Security options={optionsServices} />}
        {reload ? <Container margin="40px 0px 0px 0px"><Progress open={reload} position="relative" /></Container> : <AccidentalDamage options={optionsServices} />}
        {reload ? <Container margin="40px 0px 0px 0px"><Progress open={reload} position="relative" /></Container> : <Combo options={optionsServices} />}
        {reload ? <Container margin="40px 0px 0px 0px"><Progress open={reload} position="relative" /></Container> : <InstallmentMeans options={optionsServices} product={product} />}
      </TabsComponent>
    </CardStyled>
  );
}
